// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import myAccountDetailsStyles from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { savedOrderDetailsActionButtonsStyles } from "@conklin/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.container = {
    css: css`
        display: flex;
        gap: 16px 24px;
        flex-wrap: wrap;

        ${xScreen("lte", "sm")} {
            row-gap: 12px;
        }
    `,
};

savedOrderDetailsActionButtonsStyles.printLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.printLink,
};

savedOrderDetailsActionButtonsStyles.deleteLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.removeAllLink,
};

savedOrderDetailsActionButtonsStyles.addToListLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.addAllToListClickable,
};

savedOrderDetailsActionButtonsStyles.placeOrderLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.placeOrderLink,
};

savedOrderDetailsActionButtonsStyles.twoButtonModalStyles = {
    modal: {
        cssOverrides: {
            modalContent: css`
                &&& {
                    overflow-y: hidden;
                }
            `,
        },
    },
    submitButton: {
        color: "primary",
    },
};

savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    css: css`
        width: 100%;
        margin-left: 0;
    `,
};

savedOrderDetailsActionButtonsStyles.placeOrderWrapper = {
    css: css`
        width: 100%;
    `,
};
